/*
 * @Author: yanghailong
 * @Date: 2023-11-25 09:45:28
 * @Last Modified by: yanghailong
 * @Last Modified time: 2023-11-27 08:52:40
 */
import Konva from "konva"

class LinkPoint {
  constructor(topology, x, y, index) {
    this.topology = topology
    this.x = x
    this.y = y
    this.state = true
    this.index = index
    this.setup()
  }
  setup() {
    this.g = new Konva.Group({
      draggable: false,
      x: this.x,
      y: this.y,
    })
    this.shapeH = new Konva.Rect({
      x: 2,
      width: 18,
      height: 3,
      fill: '#00AAFF',
    })
    this.shapeV = this.shapeH.clone({
      rotation: 90,

      offset: {
        x: 7,
        y: 10,
      }
    })

    this.circle = new Konva.Circle({
      x: 10,
      y: 2,
      radius: 12,
      fill: '#fff',
    })

    this.g.add(this.circle)
    this.g.add(this.shapeH)
    this.g.add(this.shapeV)

    this.bindEvent()
    this.shapeV.hide()
  }

  addToLayer(layer) {
    layer.add(this.g)
  }

  bindEvent() {
    this.g.on('click', (e) => {
      let state = !this.state
      this.setState(state)
      this.g.fire('state-change', { state })
    })
    this.g.on('mouseover', (e) => {
      this.topology.storage.stage.container().style.cursor = 'pointer'
    })
    this.g.on('mouseout', (e) => {
      this.topology.storage.stage.container().style.cursor = 'default'
    })
  }
  setState(state) {
    this.state = state
    if (state) {
      this.shapeV.hide()
    } else {
      this.shapeV.show()
    }
  }

}




export { LinkPoint }
